import React, { Component } from "react";
import { Link } from "react-router-dom";
import Chip from "@material-ui/core/Chip";
import { Button as Btn, Card as Cd, Container, Row, Col } from "reactstrap";

import withStyles from "@material-ui/core/styles/withStyles";
import { getInspector, listVehicleTypes } from "../graphql/queries";
import gql from "graphql-tag";
import { updateInspector } from "../graphql/mutations";
import { spinnerService } from "@chevtek/react-spinners";
import SelectList from "./SelectList";
import { connect } from "react-redux";

import { API, graphqlOperation } from "aws-amplify";


import Card from "../components/Card/Card.jsx";
import CardHeader from "../components/Card/CardHeader.jsx";
import CardBody from "../components/Card/CardBody.jsx";

import * as actionTypes from "../redux/actions";
import { array } from "prop-types";
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  }
};
class UpdateInspector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      success: false,
      vehicles: [],
      selectedInspector: null,
      selectedVehicles: []
    };
  }
  deleteVehicle = item => {
    var selectedVehicles = [...this.state.selectedVehicles];
    selectedVehicles = selectedVehicles.filter(obj => obj.id !== item.id);

    let vehicles = [...this.state.vehicles];
    vehicles.push(item);
    this.setState({ selectedVehicles, vehicles });
  };
  setVehicle = item => {
    let selectedVehicles = [...this.state.selectedVehicles];
    selectedVehicles.push(item);

    let vehicles = [...this.state.vehicles];
    vehicles = vehicles.filter(obj => obj.id !== item.id);
    this.setState({ selectedVehicles, vehicles });
  };
  async componentDidMount() {
    const { client, user } = this.props;
    spinnerService.show("mySpinner");
    let { selectedVehicles, vehicles } = this.state;
    if (user) {
      try {
        const inspector = await client.query({
          query: gql(getInspector),
          fetchPolicy: `network-only`,
          variables: { id: this.props.match.params.iId }
        });

        const listVehicleTypes = await client.query({
          query: gql`
            query ListVehicleTypes(
              $filter: ModelVehicleTypeFilterInput
              $limit: Int
              $nextToken: String
            ) {
              listVehicleTypes(
                filter: $filter
                limit: $limit
                nextToken: $nextToken
              ) {
                items {
                  id
                  vehicleType
                  vehicleCategory
                  observations
                }
                nextToken
              }
            }
          `,
          fetchPolicy: `network-only`,
          variables: { limit: 1000 }
        });

        listVehicleTypes.data.listVehicleTypes.items.forEach(element => {
          if (
            inspector.data.getInspector.authorizedVehTypes !== null &&
            inspector.data.getInspector.authorizedVehTypes.includes(element.id)
          ) {
            selectedVehicles.push(element);
          } else vehicles.push(element);
        });
        this.setState({
          vehicles,
          selectedInspector: inspector.data.getInspector,
          selectedVehicles,
          success: true
        });
        spinnerService.hide("mySpinner");
      } catch (err) {
        spinnerService.hide("mySpinner");
      }
    } else {
      spinnerService.hide("mySpinner");
    }
  }
  updateInspectorForm = async () => {
    if (this.state.selectedVehicles.length === 0) {
      toast.error("Please Select Vehicle");
      return;
    }
    if (this.state.selectedInspector === null) {
      ToastContainer.error("No Inspector Found");
      return;
    }
    var items = [];
    this.state.selectedVehicles.map((item, key) => {
      items.push(item.id);
    });

    var input = {
      id: this.props.match.params.iId,
      authorizedVehTypes: items
    };

    try {
      spinnerService.show("mySpinner");
      var result = await API.graphql(
        graphqlOperation(updateInspector, { input })
      );
      spinnerService.hide("mySpinner");
      toast.success("Inspector Updated");
    } catch (e) {
      spinnerService.hide("mySpinner");
    }
  };
  cancelForm = e => {
    //this.props.location.loadData();
    this.props.history.push("../../inspector");
  };
  render() {
    let { selectedVehicles, selectedInspector, success, vehicles } = this.state;
    if (!success) return null;
    const { classes } = this.props;
    return (
      <div>
        
        <Container className="pt-lg-sm pt-2">
          <ToastContainer />
          <Row className="justify-content-center">
            <Col lg={10}>
              <Card>
                <CardHeader color="primary">
                  <h4 className={classes.cardTitleWhite}>
                    Assign Vehicles to{" "}
                    {this.state.selectedInspector !== null
                      ? this.state.selectedInspector.name
                      : null}
                  </h4>
                  <p className={classes.cardCategoryWhite}>
                    Enter Details Below
                  </p>
                </CardHeader>
                <CardBody>
                  <div class="row">
                    <div class="col">
                      <SelectList
                        heading="Vehicle"
                        data={this.state.vehicles}
                        addMethod={this.setVehicle}
                      />
                    </div>
                  </div>
                  <Cd style={{ marginTop: "20px" }}>
                    <CardHeader>Selected Vehicles</CardHeader>
                    <CardBody>
                      {this.state.selectedVehicles.length !== 0 &&
                        this.state.selectedVehicles.map((item, key) => {
                          return (
                            <Chip
                              key={key}
                              label={item.vehicleType}
                              onDelete={() => this.deleteVehicle(item)}
                              style={{ margin: 5 }}
                              color="primary"
                            />
                          );
                        }, this)}
                    </CardBody>
                  </Cd>
                  <div className="text-center">
                    <Row lg="12" className="  ">
                      <Col lg="2"></Col>
                      <Col>
                        <Btn
                          className=" btn-lg btn-block mt-2 "
                          color="primary text-center"
                          type="Btn"
                          onClick={() => this.updateInspectorForm()}
                        >
                          <large className="  text-center"> Update </large>
                        </Btn>
                      </Col>
                      <Col>
                        <Btn
                          className=" btn-lg btn-block mt-2"
                          color="default"
                          onClick={this.cancelForm}
                        >
                          Back
                        </Btn>
                      </Col>
                      <Col lg="2"></Col>
                    </Row>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.config.user,
    client: state.config.client
  };
};
export default UpdateInspector = connect(
  mapStateToProps,
  null
)(withStyles(styles)(UpdateInspector));



// WEBPACK FOOTER //
// ./src/admin/UpdateInspector.jsx